import React, { FunctionComponent } from 'react'
import { reactular } from '@vendhq/reactular'
import { Scrollable } from '@lightspeed/design-system-react'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleStatus } from '../../../state/slices/currentSale/currentSaleSlice'
import { isQuote } from '../../../functions/sale'
import { SaleActionBar } from './SaleActionBar'
import { ConfirmationHeader } from './ConfirmationHeader'
import { PrintButtons } from './PrintButtons'

export const ConfirmationPanel: FunctionComponent = () => {
  const status = useAppSelector(selectSaleStatus)

  return (
    <div className="vd-card payment-panel--action">
      <Scrollable monobrow={true} goatee={true}>
        <div className="payment-panel-content payment-panel-content--action">
          <div className="sale-confirmation-container">
            <ConfirmationHeader />
            {isQuote(status) ? null : <PrintButtons />}
          </div>
        </div>
      </Scrollable>
      <SaleActionBar />
    </div>
  )
}

export const ReactConfirmationPanel = reactular(
  ConfirmationPanel,
  [],
  'reactWrapper'
)
